var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniserverDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Minserver_Default",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#033255;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.7,
    y: 18.7,
    className: "st0",
    width: 5.1,
    height: 3.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.9,0 7.9,6.4 4.2,6.4 4.2,16.3 7.9,16.3 7.9,24.4 4.2,24.4 4.2,34.3 7.9,34.3 7.9,40.7 15.8,40.7  15.8,44 19.4,44 19.4,40.7 22,40.7 22,44 25.7,44 25.7,40.7 28.3,40.7 28.3,44 31.9,44 31.9,40.7 39.8,40.7 39.8,24.6 34.6,24.6  34.6,35.5 13,35.5 13,5.2 34.6,5.2 34.6,16.1 39.8,16.1 39.8,0  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1,7.7H15.6V33h16.4V7.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "24.3,24.5 22.4,23.5 23.5,21.4 20.7,21.4 23.3,16.2 25.3,17.2 24.2,19.3 26.9,19.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniserverDefault);
export default __webpack_public_path__ + "static/media/miniserver-default.70bd218635ce4e83a84bfac3d001f4be.svg";
export { ForwardRef as ReactComponent };